import * as angular from "angular";

angular
  .module('bringoz.admin.billing-accounts')
  .constant('BillingAccounts_PN', {
    database: 'billingAccounts',
    isBranchEntity: false
  });
